/* ============================================================================
FILE: po-katupirsia5-aneporon-texts-fr-en-es-20260305.js

MODE: TRILINGUE (FR/EN/ES) + protection lexicale stricte + couche audio locale
API:  window.PoK5AneporonTextsFR_EN_ES_20260305
ROOT: .po-k5-section[data-po-k5="aneporon"]

RÔLE:
- injecte le contenu FR/EN/ES dans les slots data-po-slot
- conserve les termes du lexique canonique en FR, quelle que soit la langue
- verrouille la traduction automatique sur le bloc
- ajoute une couche audio locale et générale sans casser le socle
- compat Shopify / multi-instances
- alias compat : window.GoodyTwinLang
============================================================================ */

(function () {
  "use strict";

  if (window.__PO_K5_ANEPORON_TEXTS_20260305__) return;
  window.__PO_K5_ANEPORON_TEXTS_20260305__ = true;
  window.__POLEX_RUNTIME_INIT__ = true;

  var STORAGE_KEY = "po_lex_lang";
  var STORAGE_KEY_COMPAT = "goody_gp_lang";
  var ROOT_SEL = '.po-k5-section[data-po-k5="aneporon"]';

  var IMG_ANEPORON = "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Aneporon_copie.png?v=1772923309";
  var IMG_ASSOCIATED_SEAL = "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Sceau_d_Aneporon_1303_2.png?v=1772897595";
  var IMG_GUIDE_NUMBER_1303 = "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Nombre_guide_1303.png?v=1773448851";

  function clampStr(v) {
    return v == null ? "" : String(v);
  }

  function normLang(raw) {
    var v = clampStr(raw).toLowerCase().trim();
    if (v.indexOf("fr") === 0) return "fr";
    if (v.indexOf("en") === 0) return "en";
    if (v.indexOf("es") === 0) return "es";
    return "";
  }

  function readStoredLang() {
    try {
      var v = normLang(localStorage.getItem(STORAGE_KEY));
      if (v) return v;
    } catch (e) {}
    try {
      var v2 = normLang(localStorage.getItem(STORAGE_KEY_COMPAT));
      if (v2) return v2;
    } catch (e) {}
    return "";
  }

  function detectBrowserLang() {
    try {
      var n = (navigator && (navigator.language || (navigator.languages && navigator.languages[0]))) || "";
      var v = normLang(n);
      if (v) return v;
    } catch (e) {}
    return "fr";
  }

  function storeLang(lang) {
    var v = normLang(lang) || "fr";
    try { localStorage.setItem(STORAGE_KEY, v); } catch (e) {}
    try { localStorage.setItem(STORAGE_KEY_COMPAT, v); } catch (e) {}
    try { document.documentElement.setAttribute("lang", v); } catch (e) {}
  }

  function getLang() {
    return readStoredLang() || detectBrowserLang() || "fr";
  }

  function notifyLocaleChanged() {
    try {
      window.dispatchEvent(new Event("po:locale-changed"));
    } catch (e) {
      try {
        var ev = document.createEvent("Event");
        ev.initEvent("po:locale-changed", true, true);
        window.dispatchEvent(ev);
      } catch (_e) {}
    }
  }

  function escapeRegExp(s) {
    return String(s).replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  }

  function uniqPush(arr, v) {
    if (!v) return;
    for (var i = 0; i < arr.length; i++) {
      if (arr[i] === v) return;
    }
    arr.push(v);
  }

  function buildVariants(term) {
    var out = [];
    var t = clampStr(term);
    if (!t) return out;

    uniqPush(out, t);
    uniqPush(out, t.replace(/’/g, "'"));
    uniqPush(out, t.replace(/'/g, "’"));

    var oe1 = t.replace(/œ/g, "oe").replace(/Œ/g, "OE");
    var oe2 = t.replace(/oe/g, "œ").replace(/OE/g, "Œ");
    uniqPush(out, oe1);
    uniqPush(out, oe2);
    uniqPush(out, oe1.replace(/’/g, "'"));
    uniqPush(out, oe1.replace(/'/g, "’"));
    uniqPush(out, oe2.replace(/’/g, "'"));
    uniqPush(out, oe2.replace(/'/g, "’"));

    var lower = t.toLowerCase();
    if (lower !== t) {
      uniqPush(out, lower);
      uniqPush(out, lower.replace(/’/g, "'"));
      uniqPush(out, lower.replace(/'/g, "’"));
      uniqPush(out, lower.replace(/œ/g, "oe"));
      uniqPush(out, lower.replace(/oe/g, "œ"));
    }

    return out;
  }

  function getSimplifiedLexiqueFRList() {
    try {
      if (window.PO_LEXICON_META && Array.isArray(window.PO_LEXICON_META.lexique_simplifie_fr)) {
        return window.PO_LEXICON_META.lexique_simplifie_fr.slice();
      }
    } catch (e) {}

    try {
      if (window.PO_LEXICON && window.PO_LEXICON.meta && Array.isArray(window.PO_LEXICON.meta.lexique_simplifie_fr)) {
        return window.PO_LEXICON.meta.lexique_simplifie_fr.slice();
      }
    } catch (e) {}

    try {
      if (window.PO_LEXIQUE_SIMPLIFIE && window.PO_LEXIQUE_SIMPLIFIE.meta && Array.isArray(window.PO_LEXIQUE_SIMPLIFIE.meta.lexique_simplifie_fr)) {
        return window.PO_LEXIQUE_SIMPLIFIE.meta.lexique_simplifie_fr.slice();
      }
    } catch (e) {}

    return [
      "Posœnnoïa",
      "Posœnnoïsme",
      "Organon posœnnoïal",
      "Katûvýs",
      "Katûvýsissence",
      "Katûsýs",
      "Katûvýsqun",
      "Balakallpa",
      "Isqun",
      "Threnisqun",
      "Ennéagone",
      "Ennéagone régulateur",
      "Sceau d’Équiphase",
      "Sceau de Syntonie",
      "Sceau d’Aísthisi",
      "Sceau d’Anépôron",
      "Anēporon",
      "Anépôron",
      "RéZonans",
      "Tiqqunbahu",
      "Takimarah",
      "Extratinrieur",
      "Posœnnomia",
      "Déterminisme du choix",
      "Addition synchrêtique",
      "Superposition de perspectives",
      "Sujet pluriel",
      "Méditations Posœnnoïales",
      "Accords Posœnnoïaux"
    ];
  }

  function buildProtectMatcher() {
    var base = getSimplifiedLexiqueFRList();
    var variants = [];
    for (var i = 0; i < base.length; i++) {
      var list = buildVariants(base[i]);
      for (var j = 0; j < list.length; j++) uniqPush(variants, list[j]);
    }
    variants.sort(function (a, b) { return b.length - a.length; });
    var parts = [];
    for (var k = 0; k < variants.length; k++) {
      parts.push(escapeRegExp(variants[k]));
    }
    return parts.length ? new RegExp("(" + parts.join("|") + ")", "g") : null;
  }

  var __PO_PROTECT_RE__ = null;

  function protectSpan(txt) {
    return '<span translate="no" class="po-lex-protect">' + clampStr(txt) + "</span>";
  }

  function protectLexiconInHTML(html) {
    var src = clampStr(html);
    if (!src) return "";
    if (!__PO_PROTECT_RE__) __PO_PROTECT_RE__ = buildProtectMatcher();
    if (!__PO_PROTECT_RE__) return src;

    var out = src.replace(__PO_PROTECT_RE__, function (m) {
      return protectSpan(m);
    });

    out = out.replace(/([0-9A-Za-zÀ-ÖØ-öø-ÿ])(<span translate="no" class="po-lex-protect">)/g, "$1 $2");
    out = out.replace(/(<\/span>)([0-9A-Za-zÀ-ÖØ-öø-ÿ])/g, "$1 $2");
    out = out.replace(/(<\/span>)(<[^\/\s>])/g, "$1 $2");
    out = out.replace(/([^\s>])(<span translate="no" class="po-lex-protect">)/g, function (_m, a, b) {
      if (a === " " || a === ">") return a + b;
      return a + " " + b;
    });

    return out;
  }

  function qs(root, sel) {
    try { return root.querySelector(sel); } catch (e) { return null; }
  }

  function setSlotText(root, slot, txt) {
    var el = qs(root, '[data-po-slot="' + slot + '"]');
    if (!el) return;
    el.textContent = clampStr(txt);
  }

  function setSlotHTML(root, slot, html) {
    var el = qs(root, '[data-po-slot="' + slot + '"]');
    if (!el) return;
    el.innerHTML = protectLexiconInHTML(html);
  }

  function setSlotImg(root, slot, data) {
    var el = qs(root, '[data-po-slot="' + slot + '"]');
    if (!el) return;
    var src = data && data.src ? data.src : "";
    var alt = data && data.alt ? data.alt : "";
    if (src) {
      el.src = src;
      el.alt = alt;
      el.removeAttribute("hidden");
      el.style.display = "";
    } else {
      el.setAttribute("hidden", "");
      el.style.display = "none";
    }
  }

  function renderList(root, slot, items) {
    var el = qs(root, '[data-po-slot="' + slot + '"]');
    if (!el) return;
    var arr = Array.isArray(items) ? items : [];
    var out = [];
    for (var i = 0; i < arr.length; i++) {
      out.push("<li>" + protectLexiconInHTML(clampStr(arr[i])) + "</li>");
    }
    el.innerHTML = out.join("");
  }

  function renderExampleBox(root, slot, exampleTitle, exampleText) {
    var el = qs(root, '[data-po-slot="' + slot + '"]');
    if (!el) return;
    if (!exampleTitle && !exampleText) {
      el.innerHTML = "";
      return;
    }
    el.innerHTML =
      '<div class="po-lex-example__title"><strong>' + protectLexiconInHTML(exampleTitle) + '</strong></div>' +
      '<div class="po-lex-example__text">' + protectLexiconInHTML(exampleText) + "</div>";
  }

  function renderWordBlocks(root, slot, blocks) {
    var el = qs(root, '[data-po-slot="' + slot + '"]');
    if (!el) return;
    var arr = Array.isArray(blocks) ? blocks : [];
    var out = [];
    for (var i = 0; i < arr.length; i++) {
      var b = arr[i] || {};
      out.push(
        '<div class="po-axis-wb">' +
          '<div class="po-axis-wb__h">' + protectLexiconInHTML(clampStr(b.head)) + '</div>' +
          '<div class="po-axis-wb__t">' + protectLexiconInHTML(clampStr(b.text)) + '</div>' +
        '</div>'
      );
    }
    el.innerHTML = out.join("");
  }

  function applyLangbar(root, lang) {
    var buttons = root.querySelectorAll("[data-po-lang]");
    for (var i = 0; i < buttons.length; i++) {
      var active = buttons[i].getAttribute("data-po-lang") === lang;
      buttons[i].setAttribute("aria-pressed", active ? "true" : "false");
      if (active) buttons[i].classList.add("is-active");
      else buttons[i].classList.remove("is-active");
    }
  }

  /* --------------------------------------------------------------------------
   * AUDIO LOCAL PAR BLOC + TEXTE GÉNÉRAL
   * -------------------------------------------------------------------------- */

  var PO_AUDIO_SYNTH = (typeof window !== "undefined" && window.speechSynthesis) ? window.speechSynthesis : null;
  var PO_AUDIO_STATE = {
    root: null,
    units: [],
    unitPos: -1,
    chunks: [],
    chunkPos: -1,
    activeKey: "",
    lang: "fr",
    voice: null
  };

  var AUDIO_UI = {
    fr: { general: "Écouter le texte", block: "Écouter ce bloc", stop: "Arrêter la lecture" },
    en: { general: "Listen to the text", block: "Listen to this section", stop: "Stop playback" },
    es: { general: "Escuchar el texto", block: "Escuchar este bloque", stop: "Detener la lectura" }
  };

  function audioUI(lang) {
    return AUDIO_UI[normLang(lang)] || AUDIO_UI.fr;
  }

  function getAudioRoots() {
    try { return document.querySelectorAll(ROOT_SEL); } catch (e) { return []; }
  }

  function getDetailBlocks(root) {
    try { return root.querySelectorAll('.po-lex-details'); } catch (e) { return []; }
  }

  function ensureAudioStyles() {
    if (document.getElementById('po-k5-audio-styles')) return;
    var style = document.createElement('style');
    style.id = 'po-k5-audio-styles';
    style.textContent =
      '.po-axis-audio-wrap{display:flex;align-items:center;gap:.6rem;margin:1rem 0 1.15rem 0;justify-content:flex-start;}' +
      '.po-axis-audio-btn{appearance:none;-webkit-appearance:none;border:1px solid rgba(184,134,11,.55);background:rgba(31,122,58,.04);color:var(--color-accent,#1f7a3a);padding:.55rem .9rem;border-radius:999px;cursor:pointer;font:inherit;font-weight:800;line-height:1.2;transition:opacity .2s ease,transform .2s ease,box-shadow .2s ease,border-color .2s ease;box-shadow:0 6px 16px rgba(31,122,58,.10);}' +
      '.po-axis-audio-btn:hover{transform:translateY(-1px);box-shadow:0 10px 26px rgba(31,122,58,.16);border-color:rgba(184,134,11,.75);}' +
      '.po-axis-audio-btn[aria-pressed="true"]{box-shadow:0 0 0 1px rgba(184,134,11,.18),0 10px 26px rgba(31,122,58,.18);background:rgba(31,122,58,.08);}' +
      '.po-lex-summary .po-axis-audio-btn{margin-left:.75rem;vertical-align:middle;flex:0 0 auto;}' +
      '@media (max-width:640px){.po-lex-summary{flex-wrap:wrap;}.po-lex-summary .po-axis-audio-btn{display:block;margin:.65rem 0 0 0;}}';
    document.head.appendChild(style);
  }

  function createAudioButton(role) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'po-axis-audio-btn';
    btn.setAttribute('data-po-audio-role', role === 'general' ? 'general' : 'detail');
    btn.setAttribute('aria-pressed', 'false');
    btn.setAttribute('translate', 'yes');
    return btn;
  }

  function ensureAudioButtons(root) {
    if (!root) return;
    ensureAudioStyles();

    var panel = root.querySelector('.po-lex-panel');
    if (panel) {
      var generalWrap = root.querySelector('.po-axis-audio-wrap[data-po-audio-role="general"]');
      if (!generalWrap) {
        generalWrap = document.createElement('div');
        generalWrap.className = 'po-axis-audio-wrap';
        generalWrap.setAttribute('data-po-audio-role', 'general');
        generalWrap.appendChild(createAudioButton('general'));

        var meta = root.querySelector('.po-axis-meta');
        var defShort = root.querySelector('[data-po-slot="def_short"]');
        var firstDetail = panel.querySelector('.po-lex-details');

        if (meta && meta.parentNode) {
          if (meta.nextSibling) meta.parentNode.insertBefore(generalWrap, meta.nextSibling);
          else meta.parentNode.appendChild(generalWrap);
        } else if (defShort && defShort.parentNode) {
          defShort.parentNode.insertBefore(generalWrap, defShort);
        } else if (firstDetail && firstDetail.parentNode) {
          firstDetail.parentNode.insertBefore(generalWrap, firstDetail);
        } else {
          panel.appendChild(generalWrap);
        }
      }
    }

    var details = getDetailBlocks(root);
    for (var i = 0; i < details.length; i++) {
      var summary = details[i].querySelector('.po-lex-summary');
      if (!summary) continue;
      var btn = summary.querySelector('.po-axis-audio-btn[data-po-audio-role="detail"]');
      if (!btn) {
        btn = createAudioButton('detail');
        summary.appendChild(btn);
      }
      btn.setAttribute('data-po-audio-index', String(i));
    }
  }

  function getTextValue(el) {
    if (!el) return '';
    var txt = '';
    try { txt = el.innerText || el.textContent || ''; } catch (e) { txt = ''; }
    return String(txt).replace(/\s+/g, ' ').replace(/\u00a0/g, ' ').trim();
  }

  function removeAudioButtonsFromClone(root) {
    if (!root || !root.querySelectorAll) return;
    var btns = root.querySelectorAll('.po-axis-audio-btn, .po-axis-audio-wrap');
    for (var i = 0; i < btns.length; i++) {
      if (btns[i] && btns[i].parentNode) btns[i].parentNode.removeChild(btns[i]);
    }
  }

  function collectGeneralText(root) {
    var parts = [];
    var slots = ['title', 'kicker', 'h_def', 'def_short', 'def_long'];
    for (var i = 0; i < slots.length; i++) {
      var el = root.querySelector('[data-po-slot="' + slots[i] + '"]');
      var txt = getTextValue(el);
      if (txt) parts.push(txt);
    }
    return parts.join('. ');
  }

  function collectDetailText(detail) {
    if (!detail) return '';
    var parts = [];
    var title = detail.querySelector('.po-lex-summary__title');
    var titleText = getTextValue(title);
    if (titleText) parts.push(titleText);

    var clone = detail.cloneNode(true);
    var summary = clone.querySelector('.po-lex-summary');
    if (summary && summary.parentNode) summary.parentNode.removeChild(summary);
    removeAudioButtonsFromClone(clone);

    var bodyText = getTextValue(clone);
    if (bodyText) parts.push(bodyText);
    return parts.join('. ');
  }

  function isWordLikeChar(ch) {
    return /[0-9A-Za-zÀ-ÖØ-öø-ÿ]/.test(ch || '');
  }

  function splitTextForSpeech(txt, maxLen) {
    var text = clampStr(txt).replace(/\s+/g, ' ').trim();
    if (!text) return [];
    var limit = Math.max(120, parseInt(maxLen, 10) || 200);
    var out = [];
    var start = 0;

    while (start < text.length) {
      var end = Math.min(start + limit, text.length);
      if (end < text.length) {
        var slice = text.slice(start, end);
        var cut = Math.max(
          slice.lastIndexOf('. '),
          slice.lastIndexOf('! '),
          slice.lastIndexOf('? '),
          slice.lastIndexOf('; '),
          slice.lastIndexOf(': '),
          slice.lastIndexOf(', ')
        );
        if (cut < Math.floor(limit * 0.55)) cut = slice.lastIndexOf(' ');
        if (cut > 0) end = start + cut + 1;
      }
      while (end < text.length && isWordLikeChar(text.charAt(end - 1)) && isWordLikeChar(text.charAt(end))) {
        end++;
      }
      var chunk = text.slice(start, end).trim();
      if (chunk) out.push(chunk);
      start = end;
    }
    return out;
  }

  function pickVoiceForLang(lang) {
    if (!PO_AUDIO_SYNTH || typeof PO_AUDIO_SYNTH.getVoices !== 'function') return null;
    var wanted = normLang(lang) || 'fr';
    var voices = [];
    try { voices = PO_AUDIO_SYNTH.getVoices() || []; } catch (e) { voices = []; }
    if (!voices.length) return null;
    for (var i = 0; i < voices.length; i++) {
      if (normLang(voices[i] && voices[i].lang) === wanted) return voices[i];
    }
    for (var j = 0; j < voices.length; j++) {
      var voiceLang = clampStr(voices[j] && voices[j].lang).toLowerCase();
      if (voiceLang.indexOf(wanted) === 0) return voices[j];
    }
    return voices[0] || null;
  }

  function buildUnits(root, role, index) {
    var units = [];
    var details = getDetailBlocks(root);
    if (role === 'general') {
      units.push({ role: 'general', index: -1 });
      for (var i = 0; i < details.length; i++) units.push({ role: 'detail', index: i });
      return units;
    }
    var start = (typeof index === 'number' && index >= 0) ? index : 0;
    for (var j = start; j < details.length; j++) units.push({ role: 'detail', index: j });
    return units;
  }

  function updateAudioPressedState() {
    var roots = getAudioRoots();
    for (var i = 0; i < roots.length; i++) {
      var btns = roots[i].querySelectorAll('.po-axis-audio-btn');
      for (var j = 0; j < btns.length; j++) btns[j].setAttribute('aria-pressed', 'false');
    }
    if (!PO_AUDIO_STATE.root || !PO_AUDIO_STATE.activeKey) return;
    var btn;
    if (PO_AUDIO_STATE.activeKey === 'general') {
      btn = PO_AUDIO_STATE.root.querySelector('.po-axis-audio-wrap[data-po-audio-role="general"] .po-axis-audio-btn[data-po-audio-role="general"]');
      if (btn) btn.setAttribute('aria-pressed', 'true');
      return;
    }
    var idx = parseInt(String(PO_AUDIO_STATE.activeKey).split(':')[1], 10);
    if (!isNaN(idx)) {
      btn = PO_AUDIO_STATE.root.querySelector('.po-axis-audio-btn[data-po-audio-role="detail"][data-po-audio-index="' + idx + '"]');
      if (btn) btn.setAttribute('aria-pressed', 'true');
    }
  }

  function refreshAudioLabels(root, lang) {
    if (!root) return;
    var ui = audioUI(lang || getLang());
    var generalBtn = root.querySelector('.po-axis-audio-wrap[data-po-audio-role="general"] .po-axis-audio-btn[data-po-audio-role="general"]');
    if (generalBtn) {
      var generalActive = (PO_AUDIO_STATE.root === root && PO_AUDIO_STATE.activeKey === 'general' && PO_AUDIO_SYNTH && (PO_AUDIO_SYNTH.speaking || PO_AUDIO_SYNTH.pending));
      generalBtn.textContent = generalActive ? ui.stop : ui.general;
    }
    var detailBtns = root.querySelectorAll('.po-axis-audio-btn[data-po-audio-role="detail"]');
    for (var i = 0; i < detailBtns.length; i++) {
      var btn = detailBtns[i];
      var idx = parseInt(btn.getAttribute('data-po-audio-index'), 10);
      var key = 'detail:' + (isNaN(idx) ? -1 : idx);
      var active = (PO_AUDIO_STATE.root === root && PO_AUDIO_STATE.activeKey === key && PO_AUDIO_SYNTH && (PO_AUDIO_SYNTH.speaking || PO_AUDIO_SYNTH.pending));
      btn.textContent = active ? ui.stop : ui.block;
    }
    updateAudioPressedState();
  }

  function refreshAllAudioLabels(lang) {
    var roots = getAudioRoots();
    for (var i = 0; i < roots.length; i++) refreshAudioLabels(roots[i], lang || getLang());
  }

  function stopAudio(silent) {
    if (PO_AUDIO_SYNTH) {
      try { PO_AUDIO_SYNTH.cancel(); } catch (e) {}
    }
    PO_AUDIO_STATE.root = null;
    PO_AUDIO_STATE.units = [];
    PO_AUDIO_STATE.unitPos = -1;
    PO_AUDIO_STATE.chunks = [];
    PO_AUDIO_STATE.chunkPos = -1;
    PO_AUDIO_STATE.activeKey = '';
    PO_AUDIO_STATE.voice = null;
    if (!silent) refreshAllAudioLabels(getLang());
    else updateAudioPressedState();
  }

  function speakCurrentChunk() {
    if (!PO_AUDIO_SYNTH) return;
    if (!PO_AUDIO_STATE.chunks.length || PO_AUDIO_STATE.chunkPos < 0 || PO_AUDIO_STATE.chunkPos >= PO_AUDIO_STATE.chunks.length) {
      PO_AUDIO_STATE.unitPos += 1;
      playCurrentUnit(true);
      return;
    }

    var txt = PO_AUDIO_STATE.chunks[PO_AUDIO_STATE.chunkPos];
    if (!txt) {
      PO_AUDIO_STATE.chunkPos += 1;
      speakCurrentChunk();
      return;
    }

    var utter = new SpeechSynthesisUtterance(txt);
    utter.lang = (PO_AUDIO_STATE.lang || getLang() || 'fr');
    if (PO_AUDIO_STATE.voice) utter.voice = PO_AUDIO_STATE.voice;
    utter.onend = function () {
      PO_AUDIO_STATE.chunkPos += 1;
      speakCurrentChunk();
    };
    utter.onerror = function () {
      PO_AUDIO_STATE.chunkPos += 1;
      speakCurrentChunk();
    };
    try { PO_AUDIO_SYNTH.speak(utter); } catch (e) {
      PO_AUDIO_STATE.chunkPos += 1;
      speakCurrentChunk();
    }
  }

  function playCurrentUnit(skipCancel) {
    if (!PO_AUDIO_SYNTH) return;
    if (!skipCancel) {
      try { PO_AUDIO_SYNTH.cancel(); } catch (e) {}
    }
    if (!PO_AUDIO_STATE.root || PO_AUDIO_STATE.unitPos < 0 || PO_AUDIO_STATE.unitPos >= PO_AUDIO_STATE.units.length) {
      stopAudio();
      return;
    }

    var unit = PO_AUDIO_STATE.units[PO_AUDIO_STATE.unitPos];
    if (!unit) {
      stopAudio();
      return;
    }

    var text = '';
    if (unit.role === 'general') {
      PO_AUDIO_STATE.activeKey = 'general';
      text = collectGeneralText(PO_AUDIO_STATE.root);
    } else {
      PO_AUDIO_STATE.activeKey = 'detail:' + unit.index;
      var details = getDetailBlocks(PO_AUDIO_STATE.root);
      var detail = details[unit.index];
      if (detail) {
        try { detail.open = true; } catch (e) {}
      }
      text = collectDetailText(detail);
    }

    PO_AUDIO_STATE.chunks = splitTextForSpeech(text, 210);
    PO_AUDIO_STATE.chunkPos = 0;
    refreshAllAudioLabels(PO_AUDIO_STATE.lang || getLang());

    if (!PO_AUDIO_STATE.chunks.length) {
      PO_AUDIO_STATE.unitPos += 1;
      playCurrentUnit(true);
      return;
    }
    speakCurrentChunk();
  }

  function startAudio(root, role, index) {
    if (!PO_AUDIO_SYNTH || !root) return;
    stopAudio(true);
    var lang = getLang();
    PO_AUDIO_STATE.root = root;
    PO_AUDIO_STATE.units = buildUnits(root, role, index);
    PO_AUDIO_STATE.unitPos = 0;
    PO_AUDIO_STATE.chunks = [];
    PO_AUDIO_STATE.chunkPos = -1;
    PO_AUDIO_STATE.activeKey = '';
    PO_AUDIO_STATE.lang = lang;
    PO_AUDIO_STATE.voice = pickVoiceForLang(lang);
    refreshAllAudioLabels(lang);
    playCurrentUnit(false);
  }

  function bindAudioButtons(root) {
    if (!root) return;
    var btns = root.querySelectorAll('.po-axis-audio-btn');
    for (var i = 0; i < btns.length; i++) {
      if (btns[i].__poAudioBound) continue;
      btns[i].addEventListener('click', function (ev) {
        ev.preventDefault();
        ev.stopPropagation();
        var role = this.getAttribute('data-po-audio-role') || 'detail';
        var index = parseInt(this.getAttribute('data-po-audio-index'), 10);
        var key = (role === 'general') ? 'general' : ('detail:' + (isNaN(index) ? -1 : index));
        var sameRoot = (PO_AUDIO_STATE.root === root);
        var sameKey = (PO_AUDIO_STATE.activeKey === key);
        if (sameRoot && sameKey && PO_AUDIO_SYNTH && (PO_AUDIO_SYNTH.speaking || PO_AUDIO_SYNTH.pending)) {
          stopAudio();
          return;
        }
        startAudio(root, role, isNaN(index) ? -1 : index);
      });
      btns[i].__poAudioBound = true;
    }
  }

  function initAudioEverywhere(lang) {
    var roots = getAudioRoots();
    for (var i = 0; i < roots.length; i++) {
      ensureAudioButtons(roots[i]);
      bindAudioButtons(roots[i]);
      refreshAudioLabels(roots[i], lang || getLang());
    }
  }

  try {
    if (PO_AUDIO_SYNTH && typeof PO_AUDIO_SYNTH.addEventListener === 'function') {
      PO_AUDIO_SYNTH.addEventListener('voiceschanged', function () {
        if (PO_AUDIO_STATE.root) PO_AUDIO_STATE.voice = pickVoiceForLang(PO_AUDIO_STATE.lang || getLang());
      });
    }
  } catch (e) {}

  /* --------------------------------------------------------------------------
   * CONTENU
   * -------------------------------------------------------------------------- */

  var CONTENT = {
    "fr": {
        "title": "Anēporon",
        "kicker": "Katûpirsia 5 — Entité isqunienne de Threnisqun : contenance des zones-limites, maintien du vide actif et réinvention du passage.",
        "cta_translate": "Proposer une traduction du concept",
        "h_def": "Définition canonique consolidée",
        "title_img": {
            "src": IMG_ANEPORON,
            "alt": "Anēporon — idéogramme"
        },
        "chip_1": "Idéogramme d’Anēporon",
        "chip_1_img": {
            "src": IMG_ANEPORON,
            "alt": "Anēporon — idéogramme"
        },
        "chip_2": "Sceau associé : Sceau d’Anépôron",
        "chip_2_img": {
            "src": IMG_ASSOCIATED_SEAL,
            "alt": "Sceau d’Anépôron — idéogramme conceptuel"
        },
        "chip_3": "Fréquence d’alignement 1303",
        "chip_3_img": {
            "src": IMG_GUIDE_NUMBER_1303,
            "alt": "Fréquence d’alignement 1303"
        },
        "def_short": "Anēporon est l’entité isqunienne des zones-limites issue de la densification opérative du Sceau d’Anépôron. Elle contient la chute, maintient la fécondité du vide actif et rend les fragments disponibles à une recomposition possible.",
        "def_long": "<p><strong>Anēporon</strong> s’active dans Threnisqun lorsque l’effondrement devient lisible, situé et susceptible d’une intervention rituélique. Le Sceau d’Anépôron régule à l’échelle structurelle dans Isqun ; Anēporon en constitue la présence densifiée, activable au cœur d’une situation concrète.</p><p>Elle accueille l’effondrement comme matière vibratoire, stabilise le choc, contient le vide afin qu’il garde sa puissance de devenir, puis redistribue les fragments pour qu’un ordre latent redevienne respirable. Elle restaure moins une forme antérieure qu’elle ne préserve la possibilité qu’une forme nouvelle puisse recommencer à se constituer.</p><p>Anēporon n’est pas une porte retrouvée : elle est le champ qui rend possible la réinvention du passage là où toute traversée semblait abolie.</p>",
        "h_features": "Repères structurants",
        "h_questions": "Tests d’usage",
        "h_family": "Relations systémiques",
        "h_wordbuild": "Morphogenèse, fréquence et activation",
        "hint_fold": "déplier",
        "example_title": "Phrase opérative",
        "example": "« Anēporon : je descends dans le puits noir lumineux, je laisse le souffle brisé contenir la chute, et l’ordre latent recommence à respirer. »",
        "features": [
            "Statut : entité isqunienne de Threnisqun, émanation du Sceau d’Anépôron.",
            "Champ : densité opérative des zones-limites, des écroulements et des « trous vibratoires ».",
            "Fonction principale : contenance des effondrements entropiques.",
            "Action : accueillir la chute, stabiliser le choc, maintenir le vide actif et redistribuer les fragments.",
            "Fréquence d’alignement : 1303.",
            "État du Souffle associé : Paradoxe ; traversée des paradoxes de l’infini.",
            "Rythme d’invocation : souffle brisé — vibration descendante — puits de mémoire.",
            "Sceau source : Sceau d’Anépôron, pôle régulateur d’Isqun."
        ],
        "questions": [
            "Si tout se désagrège sans prise : « Anēporon contient ».",
            "Si le vide devient stérile ou aspirant : « Anēporon féconde le vide ».",
            "S’il n’existe plus de passage perceptible : « Anēporon ouvre le champ noir de recomposition ».",
            "La continuité est-elle seulement entravée, ou la structure a-t-elle perdu toute faculté de traversée ?",
            "Quels fragments demeurent actifs lorsque la totalité antérieure a cessé de tenir ?",
            "Quel geste minimal permet au vide de rester une réserve de devenir plutôt qu’un néant stérile ?"
        ],
        "family_1": "<p><strong>Logique Isqun → Threnisqun :</strong> le Sceau d’Anépôron veille, filtre et régule les dynamiques de dissolution à l’échelle structurelle. Anēporon intervient lorsque cette régulation se densifie en présence située : elle répond à l’effondrement devenu expérience, seuil ou crise perceptible.</p>",
        "family_2": "<p><strong>Syntonies katûvýsiennes :</strong> Extratinrieur rend sensible l’interface entre l’effondrement intérieur et celui du monde ; Katûvýsissence stabilise la mémoire des implosions ; Tiqqunbahu transforme les résidus en fragments recomposables ; Déterminisme du choix rend une orientation de nouveau possible ; Posœnnomia offre un champ d’expérimentation pour les crises et passages collectifs.</p>",
        "word_blocks": [
            {
                "head": "Position ontologique",
                "text": "Anēporon intervient au temps obscur séparant la disparition d’un ordre de l’apparition d’une nouvelle possibilité. Elle accorde une dignité opérative à la chute, au silence, à la désorientation et à la suspension, sans imposer une renaissance prématurée."
            },
            {
                "head": "Morphogenèse linguistique ajustée",
                "text": "Anēporon est une construction posœnnoïale élaborée à partir du champ sémantique grec attesté de ἄπορος / ἄπορον et de ἀπορία : absence de passage, impasse, état où aucune voie praticable ne se donne encore. La graphie matricielle ΑΝΕΠΩΡΟΝ relève de la construction propre au corpus et porte la formule : « Ce qui, bien qu’infranchissable, devient traversable par retournement intérieur. »"
            },
            {
                "head": "Fréquence 1303 — précision gématrique",
                "text": "La valeur grecque 1156 correspond à la graphie ΑΝΕΠΩΡΟΝ. La valeur latine 147 correspond au syntagme SCEAU ANEPORON dans le calcul alphabétique simple. Leur addition donne 1303. Ce nombre est premier : sa genèse est composite par addition, tandis que sa nature arithmétique demeure irréductible. La réduction 1 + 3 + 0 + 3 conduit à 7, qualité de seuil et d’écart fécond."
            },
            {
                "head": "Rituel d’activation — Saut dans l’ombre stable",
                "text": "Se tenir debout, yeux fermés, bras le long du corps. Inspirer par le nez et expirer bruyamment par la bouche neuf fois. Visualiser sous les pieds un puits noir lumineux contenant la mémoire des effondrements passés. Prononcer lentement A–nē–po–ron en laissant le son vibrer dans sa descente. Laisser ensuite le corps osciller doucement, comme si un sol invisible se déplaçait, sans opposer de résistance."
            },
            {
                "head": "Moments privilégiés",
                "text": "Crise existentielle, épuisement profond, perte de foi, silence intérieur total, effondrement d’un projet ; avant une transformation majeure, lorsque l’enjeu consiste à accueillir ce qui ne reviendra plus sous sa forme antérieure."
            },
            {
                "head": "Portée cosmologique et poïétique",
                "text": "Anēporon veille aux confins où les structures mortes continuent de produire de la dispersion. Elle décompose les systèmes saturés, recueille leurs résidus et maintient le champ noir de recomposition jusqu’à l’apparition d’un ordre latent. Dans la création, elle rend le fragment de nouveau disponible au geste."
            }
        ],
        "wordbuild_notes": [
            "Psychique : immobilité spiralée et stabilisation de la perte d’axe.",
            "Systémique : fragmentation intégrée et limitation de la propagation de l’effondrement.",
            "Cosmique : silence, vision d’absorption et maintien d’un vide fécond.",
            "Poïétique : réancrage corporel et remise à disposition des fragments créatifs.",
            "Distinction canonique : le Sceau d’Anépôron régule dans Isqun ; Anēporon agit comme entité dans Threnisqun.",
            "Le terme « entropique » conserve ici une portée analogique pour les champs psychiques, sociaux, symboliques et poïétiques, sauf lorsqu’un modèle physique précis est explicitement mobilisé."
        ]
    },
    "en": {
        "title": "Anēporon",
        "kicker": "Katûpirsia 5 — Isqunian entity of Threnisqun: containment of limit-zones, preservation of active emptiness, and reinvention of passage.",
        "cta_translate": "Suggest a translation of the concept",
        "h_def": "Consolidated canonical definition",
        "title_img": {
            "src": IMG_ANEPORON,
            "alt": "Anēporon — ideogram"
        },
        "chip_1": "Anēporon ideogram",
        "chip_1_img": {
            "src": IMG_ANEPORON,
            "alt": "Anēporon — ideogram"
        },
        "chip_2": "Associated seal: Sceau d’Anépôron",
        "chip_2_img": {
            "src": IMG_ASSOCIATED_SEAL,
            "alt": "Sceau d’Anépôron — conceptual ideogram"
        },
        "chip_3": "Alignment frequency 1303",
        "chip_3_img": {
            "src": IMG_GUIDE_NUMBER_1303,
            "alt": "Alignment frequency 1303"
        },
        "def_short": "Anēporon is the Isqunian entity of limit-zones arising from the operative densification of Sceau d’Anépôron. It holds the fall, preserves the fertility of active emptiness, and makes fragments available for possible recomposition.",
        "def_long": "<p><strong>Anēporon</strong> activates within Threnisqun when collapse becomes legible, situated, and open to ritual intervention. Sceau d’Anépôron regulates at the structural level within Isqun; Anēporon is its densified, activable presence at the heart of a concrete situation.</p><p>It receives collapse as vibratory matter, stabilises the shock, holds emptiness so that it retains its power of becoming, then redistributes fragments so that a latent order may become breathable again. Rather than restoring a former form, it safeguards the possibility that a new form may begin to constitute itself.</p><p>Anēporon is not a recovered door: it is the field that makes the reinvention of passage possible where every crossing seemed abolished.</p>",
        "h_features": "Structural markers",
        "h_questions": "Usage tests",
        "h_family": "Systemic relations",
        "h_wordbuild": "Morphogenesis, frequency, and activation",
        "hint_fold": "unfold",
        "example_title": "Operative phrase",
        "example": "“Anēporon: I descend into the luminous black well, I let the broken breath hold the fall, and latent order begins to breathe again.”",
        "features": [
            "Status: Isqunian entity of Threnisqun, emanation of Sceau d’Anépôron.",
            "Field: operative density of limit-zones, collapses, and ‘vibratory holes’.",
            "Main function: containment of entropic collapses.",
            "Action: receive the fall, stabilise the shock, preserve active emptiness, and redistribute fragments.",
            "Alignment frequency: 1303.",
            "Associated state of the Souffle: Paradox; crossing the paradoxes of infinity.",
            "Invocation rhythm: broken breath — descending vibration — memory well.",
            "Source seal: Sceau d’Anépôron, regulatory pole of Isqun."
        ],
        "questions": [
            "If everything disintegrates without purchase: ‘Anēporon contains.’",
            "If emptiness becomes sterile or aspirating: ‘Anēporon fertilises emptiness.’",
            "If no passage remains perceptible: ‘Anēporon opens the black field of recomposition.’",
            "Is continuity merely obstructed, or has the structure lost every capacity for passage?",
            "Which fragments remain active once the former totality has ceased to hold?",
            "What minimal gesture allows emptiness to remain a reserve of becoming rather than a sterile void?"
        ],
        "family_1": "<p><strong>Isqun → Threnisqun logic:</strong> Sceau d’Anépôron watches over, filters, and regulates dynamics of dissolution at the structural level. Anēporon intervenes when this regulation densifies into a situated presence: it responds to collapse once collapse has become experience, threshold, or perceptible crisis.</p>",
        "family_2": "<p><strong>Katûvýsian syntonies:</strong> Extratinrieur makes the interface between inner collapse and the collapse of the world perceptible; Katûvýsissence stabilises the memory of implosions; Tiqqunbahu turns residues into recomposable fragments; Déterminisme du choix makes orientation possible again; Posœnnomia provides an experimental field for collective crises and passages.</p>",
        "word_blocks": [
            {
                "head": "Ontological position",
                "text": "Anēporon acts in the dark interval between the disappearance of an order and the emergence of a new possibility. It grants operative dignity to falling, silence, disorientation, and suspension without imposing premature rebirth."
            },
            {
                "head": "Adjusted linguistic morphogenesis",
                "text": "Anēporon is a Posœnnoïal construction developed from the attested Greek semantic field of ἄπορος / ἄπορον and ἀπορία: absence of passage, impasse, a state in which no practicable way is yet given. The matrix spelling ΑΝΕΠΩΡΟΝ belongs to the corpus’s own construction and bears the formula: ‘That which, though impassable, becomes traversable through inner reversal.’"
            },
            {
                "head": "Frequency 1303 — gematric clarification",
                "text": "The Greek value 1156 corresponds to the spelling ΑΝΕΠΩΡΟΝ. The Latin value 147 corresponds to the phrase SCEAU ANEPORON in simple alphabetic calculation. Their sum is 1303. This number is prime: its genesis is composite through addition, while its arithmetic nature remains irreducible. The reduction 1 + 3 + 0 + 3 leads to 7, a quality of threshold and fertile interval."
            },
            {
                "head": "Activation ritual — Leap into stable shadow",
                "text": "Stand with eyes closed and arms alongside the body. Inhale through the nose and exhale audibly through the mouth nine times. Visualise beneath the feet a luminous black well containing the memory of past collapses. Slowly pronounce A–nē–po–ron, allowing the sound to vibrate as it descends. Then let the body sway gently, as though an invisible ground were moving, without resisting."
            },
            {
                "head": "Privileged moments",
                "text": "Existential crisis, profound exhaustion, loss of faith, total inner silence, collapse of a project; before a major transformation, when the task is to receive what will not return in its former form."
            },
            {
                "head": "Cosmological and poietic scope",
                "text": "Anēporon watches over the confines where dead structures continue to generate dispersion. It decomposes saturated systems, gathers their residues, and sustains the black field of recomposition until a latent order appears. In creation, it makes the fragment available to gesture again."
            }
        ],
        "wordbuild_notes": [
            "Psychic: spiral stillness and stabilisation of lost axis.",
            "Systemic: integrated fragmentation and limitation of collapse propagation.",
            "Cosmic: silence, absorption vision, and preservation of fertile emptiness.",
            "Poietic: bodily re-anchoring and renewed availability of creative fragments.",
            "Canonical distinction: Sceau d’Anépôron regulates within Isqun; Anēporon acts as an entity within Threnisqun.",
            "The term ‘entropic’ retains an analogical scope here for psychic, social, symbolic, and poietic fields, except where a precise physical model is explicitly mobilised."
        ]
    },
    "es": {
        "title": "Anēporon",
        "kicker": "Katûpirsia 5 — Entidad isquniana de Threnisqun: contención de las zonas-límite, preservación del vacío activo y reinvención del paso.",
        "cta_translate": "Proponer una traducción del concepto",
        "h_def": "Definición canónica consolidada",
        "title_img": {
            "src": IMG_ANEPORON,
            "alt": "Anēporon — ideograma"
        },
        "chip_1": "Ideograma de Anēporon",
        "chip_1_img": {
            "src": IMG_ANEPORON,
            "alt": "Anēporon — ideograma"
        },
        "chip_2": "Sello asociado: Sceau d’Anépôron",
        "chip_2_img": {
            "src": IMG_ASSOCIATED_SEAL,
            "alt": "Sceau d’Anépôron — ideograma conceptual"
        },
        "chip_3": "Frecuencia de alineación 1303",
        "chip_3_img": {
            "src": IMG_GUIDE_NUMBER_1303,
            "alt": "Frecuencia de alineación 1303"
        },
        "def_short": "Anēporon es la entidad isquniana de las zonas-límite surgida de la densificación operativa de Sceau d’Anépôron. Contiene la caída, preserva la fecundidad del vacío activo y vuelve disponibles los fragmentos para una recomposición posible.",
        "def_long": "<p><strong>Anēporon</strong> se activa en Threnisqun cuando el derrumbe se vuelve legible, situado y abierto a una intervención ritual. Sceau d’Anépôron regula a escala estructural en Isqun; Anēporon constituye su presencia densificada y activable en el centro de una situación concreta.</p><p>Acoge el derrumbe como materia vibratoria, estabiliza el impacto, contiene el vacío para que conserve su potencia de devenir y redistribuye los fragmentos para que un orden latente vuelva a ser respirable. Más que restaurar una forma anterior, preserva la posibilidad de que una forma nueva comience a constituirse.</p><p>Anēporon no es una puerta recuperada: es el campo que hace posible reinventar el paso allí donde toda travesía parecía abolida.</p>",
        "h_features": "Referentes estructurantes",
        "h_questions": "Pruebas de uso",
        "h_family": "Relaciones sistémicas",
        "h_wordbuild": "Morfogénesis, frecuencia y activación",
        "hint_fold": "desplegar",
        "example_title": "Frase operativa",
        "example": "« Anēporon: desciendo al pozo negro luminoso, dejo que el aliento quebrado contenga la caída y el orden latente vuelve a respirar. »",
        "features": [
            "Estatuto: entidad isquniana de Threnisqun, emanación de Sceau d’Anépôron.",
            "Campo: densidad operativa de las zonas-límite, los derrumbes y los « agujeros vibratorios ».",
            "Función principal: contención de los derrumbes entrópicos.",
            "Acción: acoger la caída, estabilizar el impacto, preservar el vacío activo y redistribuir los fragmentos.",
            "Frecuencia de alineación: 1303.",
            "Estado del Souffle asociado: Paradoja; travesía de las paradojas del infinito.",
            "Ritmo de invocación: aliento quebrado — vibración descendente — pozo de memoria.",
            "Sello fuente: Sceau d’Anépôron, polo regulador de Isqun."
        ],
        "questions": [
            "Si todo se desagrega sin asidero: « Anēporon contiene ».",
            "Si el vacío se vuelve estéril o aspirante: « Anēporon fecunda el vacío ».",
            "Si ya no existe un paso perceptible: « Anēporon abre el campo negro de recomposición ».",
            "¿La continuidad está solamente obstruida o la estructura ha perdido toda capacidad de travesía?",
            "¿Qué fragmentos permanecen activos cuando la totalidad anterior ha dejado de sostenerse?",
            "¿Qué gesto mínimo permite que el vacío siga siendo una reserva de devenir en vez de un vacío estéril?"
        ],
        "family_1": "<p><strong>Lógica Isqun → Threnisqun:</strong> Sceau d’Anépôron vela, filtra y regula las dinámicas de disolución a escala estructural. Anēporon interviene cuando esta regulación se densifica en presencia situada: responde al derrumbe convertido en experiencia, umbral o crisis perceptible.</p>",
        "family_2": "<p><strong>Sintonías katûvýsiennes:</strong> Extratinrieur hace perceptible la interfaz entre el derrumbe interior y el del mundo; Katûvýsissence estabiliza la memoria de las implosiones; Tiqqunbahu transforma los residuos en fragmentos recomponibles; Déterminisme du choix vuelve posible una orientación; Posœnnomia ofrece un campo de experimentación para las crisis y los pasos colectivos.</p>",
        "word_blocks": [
            {
                "head": "Posición ontológica",
                "text": "Anēporon actúa en el intervalo oscuro entre la desaparición de un orden y la aparición de una nueva posibilidad. Concede dignidad operativa a la caída, al silencio, a la desorientación y a la suspensión, sin imponer un renacimiento prematuro."
            },
            {
                "head": "Morfogénesis lingüística ajustada",
                "text": "Anēporon es una construcción posœnnoïal elaborada a partir del campo semántico griego atestiguado de ἄπορος / ἄπορον y ἀπορία: ausencia de paso, impasse, estado en el que todavía no se ofrece ninguna vía practicable. La grafía matricial ΑΝΕΠΩΡΟΝ pertenece a la construcción propia del corpus y porta la fórmula: « Aquello que, aunque infranqueable, se vuelve atravesable por un giro interior. »"
            },
            {
                "head": "Frecuencia 1303 — precisión gemátrica",
                "text": "El valor griego 1156 corresponde a la grafía ΑΝΕΠΩΡΟΝ. El valor latino 147 corresponde al sintagma SCEAU ANEPORON en el cálculo alfabético simple. Su suma da 1303. Este número es primo: su génesis es compuesta por adición, mientras su naturaleza aritmética permanece irreductible. La reducción 1 + 3 + 0 + 3 conduce a 7, cualidad de umbral y de intervalo fecundo."
            },
            {
                "head": "Ritual de activación — Salto en la sombra estable",
                "text": "Permanecer de pie, con los ojos cerrados y los brazos a lo largo del cuerpo. Inspirar por la nariz y expirar ruidosamente por la boca nueve veces. Visualizar bajo los pies un pozo negro luminoso que contiene la memoria de los derrumbes pasados. Pronunciar lentamente A–nē–po–ron, dejando que el sonido vibre en su descenso. Permitir después que el cuerpo oscile suavemente, como si un suelo invisible se desplazara, sin oponer resistencia."
            },
            {
                "head": "Momentos privilegiados",
                "text": "Crisis existencial, agotamiento profundo, pérdida de fe, silencio interior total, derrumbe de un proyecto; antes de una transformación mayor, cuando el desafío consiste en acoger aquello que ya no volverá bajo su forma anterior."
            },
            {
                "head": "Alcance cosmológico y poiético",
                "text": "Anēporon vela en los confines donde las estructuras muertas continúan generando dispersión. Descompone los sistemas saturados, recoge sus residuos y sostiene el campo negro de recomposición hasta que aparece un orden latente. En la creación, vuelve a poner el fragmento a disposición del gesto."
            }
        ],
        "wordbuild_notes": [
            "Psíquico: inmovilidad espiral y estabilización de la pérdida de eje.",
            "Sistémico: fragmentación integrada y limitación de la propagación del derrumbe.",
            "Cósmico: silencio, visión de absorción y preservación de un vacío fecundo.",
            "Poiético: reanclaje corporal y nueva disponibilidad de los fragmentos creativos.",
            "Distinción canónica: Sceau d’Anépôron regula en Isqun; Anēporon actúa como entidad en Threnisqun.",
            "El término « entrópico » conserva aquí un alcance analógico para los campos psíquicos, sociales, simbólicos y poiéticos, salvo cuando se moviliza explícitamente un modelo físico preciso."
        ]
    }
};

  function applyContent(root, lang) {
    var c = CONTENT[lang] || CONTENT.fr;
    setSlotImg(root, 'title_img', c.title_img);
    setSlotText(root, 'title', c.title);
    setSlotText(root, 'kicker', c.kicker);
    setSlotText(root, 'h_def', c.h_def);
    setSlotText(root, 'chip_1', c.chip_1);
    setSlotImg(root, 'chip_1_img', c.chip_1_img);
    setSlotText(root, 'chip_2', c.chip_2);
    setSlotImg(root, 'chip_2_img', c.chip_2_img);
    setSlotText(root, 'chip_3', c.chip_3);
    setSlotImg(root, 'chip_3_img', c.chip_3_img);
    setSlotHTML(root, 'def_short', c.def_short);
    setSlotHTML(root, 'def_long', c.def_long);
    setSlotText(root, 'h_features', c.h_features);
    setSlotText(root, 'hint_fold', c.hint_fold);
    renderList(root, 'features', c.features);
    setSlotText(root, 'h_questions', c.h_questions);
    setSlotText(root, 'hint_fold2', c.hint_fold);
    renderList(root, 'questions', c.questions);
    renderExampleBox(root, 'example_box', c.example_title, c.example);
    setSlotText(root, 'h_family', c.h_family);
    setSlotText(root, 'hint_fold3', c.hint_fold);
    setSlotHTML(root, 'family_1', c.family_1);
    setSlotHTML(root, 'family_2', c.family_2);
    setSlotText(root, 'h_wordbuild', c.h_wordbuild);
    renderWordBlocks(root, 'wordbuild_blocks', c.word_blocks);
    renderList(root, 'wordbuild_notes', c.wordbuild_notes);
    setSlotText(root, 'cta_translate', c.cta_translate);
    applyLangbar(root, lang);
  }

  function lockTranslation(root) {
    if (!root) return;
    root.setAttribute('translate', 'no');
    root.classList.add('notranslate');
    var scope = root.querySelector('[data-po-lex-scope]');
    if (scope) {
      scope.setAttribute('translate', 'no');
      scope.classList.add('notranslate');
    }
  }

  function bindLangButtons(root) {
    var buttons = root.querySelectorAll('[data-po-lang]');
    for (var i = 0; i < buttons.length; i++) {
      if (buttons[i].__poLangBound) continue;
      buttons[i].addEventListener('click', function () {
        setLang(this.getAttribute('data-po-lang'));
      });
      buttons[i].__poLangBound = true;
    }
  }

  function applyAll(lang) {
    var safeLang = normLang(lang) || getLang();
    var roots = document.querySelectorAll(ROOT_SEL);
    for (var i = 0; i < roots.length; i++) {
      lockTranslation(roots[i]);
      applyContent(roots[i], safeLang);
      bindLangButtons(roots[i]);
    }
    initAudioEverywhere(safeLang);
  }

  function setLang(lang) {
    var safeLang = normLang(lang) || 'fr';
    storeLang(safeLang);
    __PO_PROTECT_RE__ = null;
    applyAll(safeLang);
    notifyLocaleChanged();
    return safeLang;
  }

  function init() {
    storeLang(getLang());
    applyAll(getLang());
  }

  window.PoK5AneporonTextsFR_EN_ES_20260305 = {
    init: init,
    getLang: getLang,
    setLang: setLang,
    normLang: normLang,
    stopAudio: stopAudio
  };

  window.GoodyTwinLang = window.GoodyTwinLang || {};
  window.GoodyTwinLang.getLang = getLang;
  window.GoodyTwinLang.setLang = setLang;
  window.GoodyTwinLang.init = init;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
